import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// Importar páginas
import Portada from '@/pages/portada/'
import Presentacion from '@/pages/presentacion/presentacion'

export default new Router({
  routes: [
      {
        path: '/',
        name: 'portada',
        component: Portada
      },
      {
        path: '/presentacion/:unipage',
        name: 'presentacion',
        component: Presentacion
      }
  ]
})
